import React from "react";

interface CloseButtonProps {
    onClose: () => void;
    top?: string
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClose, top='10px' }) => {
    return (
        <span onClick={onClose} className="offcanvas-close-btn cursor-pointer" style={{ top }}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="19.3582" cy="19.3542" r="16.0183" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M24.375 24.375L14.375 14.375" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.375 24.375L24.375 14.375" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
    );
};

export default CloseButton;